import { createWithdrawalRequest, fetchPeriodActsGenerate } from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  withdrawalPeriod: null,
  isLoadingWithdrawalPeriod: false,
  withdrawalPeriodError: null,
};

const mutations = {
  SET_LOADING_WITHDRAWAL_PERIOD(state, isLoadingPeriod) {
    state.isLoadingWithdrawalPeriod = isLoadingPeriod;
  },
  SET_WITHDRAWAL_PERIOD(state, period) {
    state.withdrawalPeriod = period;
  },
  SET_WITHDRAWAL_PERIOD_ERROR(state, error) {
    state.withdrawalPeriodError = error;
  },
};

const actions = {
  async fetchWithdrawalPeriod({ commit, dispatch }) {
    commit('SET_LOADING_WITHDRAWAL_PERIOD', true);
    commit('SET_WITHDRAWAL_PERIOD_ERROR', null);

    try {
      const withdrawalPeriod = await fetchPeriodActsGenerate();
      commit('SET_WITHDRAWAL_PERIOD', withdrawalPeriod);

      return withdrawalPeriod;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при отриманні даних про період виводу коштів';

      commit('SET_WITHDRAWAL_PERIOD_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося отримати дані про період виводу коштів користувача',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_WITHDRAWAL_PERIOD', false);
    }
  },
  async createWithdrawalRequest({ dispatch }, { userId, amount, amountActual, comment, recipientData }) {
    try {
      return await createWithdrawalRequest({ userId, amount, amountActual, comment, recipientData });
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при створенні запиту на вивід коштів';

      dispatch('notificationModule/showNotificationErrorMessage', {
        error: error,
        title: 'Не вдалося сформувати запит на вивід коштів користувача',
        message: errorMessage,
      }, { root: true });

      throw error;
    }
  },
};

const getters = {
  isWithdrawalPeriodLoading: (state) => state.isLoadingWithdrawalPeriod,
  isWithdrawalPeriodDataReady: (state) => !state.isLoadingWithdrawalPeriod && state.withdrawalPeriod !== null,
  withdrawalPeriodError: (state) => state.withdrawalPeriodError,
  getWithdrawalPeriod: (state) => state.withdrawalPeriod,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
